// eslint-disable-next-line no-restricted-imports
import {
  Configuration,
  DefaultApi as NotificationApi,
  DefaultApiGetMessagesRequest as NotificationApiGetMessagesRequest,
  DefaultApiPostMessageRequest as NotificationApiReadMessageRequest,
} from '@eih-netbroker/api-notification';
import { AxiosInstance } from 'axios';
import { IConfigAPI } from '../config';
import { ResourceHeadersWithToken } from '../services/useResource';
import { BaseResource } from './base.resource';

export type GetMessagesRequest = Omit<NotificationApiGetMessagesRequest, keyof ResourceHeadersWithToken>;

export type ReadMessageRequest = Omit<NotificationApiReadMessageRequest, keyof ResourceHeadersWithToken>;

export class NotificationResource extends BaseResource {
  // Name has to be overridden, since the build job renames it to 'r' and
  // every resource class will have the same name
  // @ts-ignore
  public static name = 'NotificationResource';

  private notificationApi: NotificationApi;

  constructor(axiosInstance: AxiosInstance, basePath: string, configApi: IConfigAPI) {
    super(axiosInstance, `${basePath}${configApi.usUrl.notification}`, configApi);
    this.notificationApi = new NotificationApi(
      new Configuration({
        basePath: `${basePath}${configApi.usUrl.notification}`,
      }),
      `${basePath}${configApi.usUrl.notification}`,
      axiosInstance,
    );
  }

  public async getUnreadMessageCount(headers: ResourceHeadersWithToken) {
    return this.notificationApi.getCountOfUnreadMessages(headers);
  }

  public async getMessages(request: GetMessagesRequest, headers: ResourceHeadersWithToken) {
    return this.notificationApi.getMessages({ ...request, ...headers });
  }

  public async readMessage(request: ReadMessageRequest, headers: ResourceHeadersWithToken) {
    return this.notificationApi.postMessage({ ...request, ...headers });
  }

  public async readAllMessages(headers: ResourceHeadersWithToken) {
    return this.notificationApi.patchMessages(headers);
  }

  getVersion() {
    return this.notificationApi.getVersion();
  }
}
